/* sp-search-v2.js – Such-Overlay nach Canvas Board 240 v2 (Zustände C, A, D). Markup: sections/sp-search-v2.liquid.
   Hängt [data-sp2s] unter das Suchfeld von #search-drawer, blendet die bisherige Theme-Ergebnisliste aus (Klasse sp2s-on)
   und zeigt: C = Startzustand (Liquid), A = Produktkarten über /search/suggest.json, D = ähnliche Treffer / Hilfe. */
(function () {
  'use strict';
  var box = document.querySelector('[data-sp2s]');
  var drawer = document.getElementById('search-drawer');
  if (!box || !drawer || drawer.dataset.sp2s) return;
  var form = drawer.querySelector('form');
  var head = drawer.querySelector('.search-input');
  var input = head ? head.querySelector('input[type="search"]') : null;
  if (!form || !head || !input) return;
  drawer.dataset.sp2s = '1';

  var cfg = {};
  try { cfg = JSON.parse(box.querySelector('[data-sp2s-cfg]').textContent); } catch (e) {}
  var EN = !!cfg.en, ROOT = cfg.root || '/', VAT = cfg.vat || 1.19;
  if (ROOT.slice(-1) !== '/') ROOT += '/';
  var T = EN ? {
    hits: function (n, q) { return '<b>' + n + (n === 1 ? ' result' : ' results') + '</b> for „' + esc(q) + '“'; },
    all: 'All results', cats: 'In categories', sugg: 'Suggestions', net: 'net', gross: 'gross', from: 'from ',
    none: function (q) { return 'No exact results for „' + esc(q) + '“.'; },
    show: function (c) { return 'Showing results for <b>' + esc(c) + '</b>'; },
    orig: function (q) { return 'search „' + esc(q) + '“ anyway'; },
    nothing: 'Nothing found – maybe one of these?', more: 'View all', models: function (n) { return n + ' models'; },
    helpH: 'We help', helpT: 'We call you back', helpS: 'Name and number are enough.', helpB: 'Request a callback',
    loc: 'de-DE'
  } : {
    hits: function (n, q) { return '<b>' + n + (n === 1 ? ' Treffer' : ' Treffer') + '</b> für „' + esc(q) + '“'; },
    all: 'Alle Ergebnisse', cats: 'In Kategorien', sugg: 'Vorschläge', net: 'netto', gross: 'brutto', from: 'ab ',
    none: function (q) { return 'Keine genauen Treffer für „' + esc(q) + '“.'; },
    show: function (c) { return 'Wir zeigen dir Treffer für <b>' + esc(c) + '</b>'; },
    orig: function (q) { return 'trotzdem „' + esc(q) + '“ suchen'; },
    nothing: 'Nichts gefunden – vielleicht eines davon?', more: 'Alle ansehen', models: function (n) { return n + ' Modelle'; },
    helpH: 'Wir helfen', helpT: 'Wir rufen dich zurück', helpS: 'Name und Nummer reichen.', helpB: 'Rückruf anfordern',
    loc: 'de-DE'
  };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function eur(v) { return Number(v).toLocaleString(T.loc, { style: 'currency', currency: 'EUR' }); }
  function clean(u) { return String(u || '').split('?')[0]; }
  function sized(src, w) { if (!src) return ''; return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w; }
  function searchUrl(q) { return (cfg.search || ROOT + 'search') + '?q=' + encodeURIComponent(q) + '&type=product'; }

  /* Einhängen */
  head.insertAdjacentElement('afterend', box);
  box.hidden = false;
  drawer.classList.add('sp2s-on');
  var idle = box.querySelector('[data-sp2s-idle]');
  var res = box.querySelector('[data-sp2s-res]');

  /* Letzte Suchen (gleicher Speicher wie die bisherige Suche: sp-recent-searches) */
  var KEY = 'sp-recent-searches';
  function recent() { try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a.filter(function (t) { return typeof t === 'string' && t.trim(); }) : []; } catch (e) { return []; } }
  function saveRecent(t) {
    t = (t || '').trim(); if (!t) return;
    var a = recent().filter(function (x) { return x.toLowerCase() !== t.toLowerCase(); }); a.unshift(t);
    try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, 5))); } catch (e) {}
  }
  function renderRecent() {
    var wrap = box.querySelector('[data-sp2s-recent]'), list = box.querySelector('[data-sp2s-recent-list]');
    if (!wrap || !list) return;
    var a = recent();
    wrap.hidden = !a.length;
    list.innerHTML = a.map(function (t) { return '<button type="button" class="sp2s-chip sp2s-chip--r" data-sp2s-q="' + esc(t) + '">' + esc(t) + '</button>'; }).join('');
  }
  renderRecent();
  drawer.addEventListener('dialog:after-show', renderRecent);

  /* Suche */
  var timer = 0, ctrl = null, seq = 0;
  function suggest(q, signal) {
    var url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,query&resources[limit]=8&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag';
    return fetch(url, { signal: signal, headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (d) {
        var r = (d && d.resources && d.resources.results) || {};
        return { products: r.products || [], collections: r.collections || [], queries: r.queries || [] };
      });
  }
  function showIdle() { idle.hidden = false; res.hidden = true; res.innerHTML = ''; }
  function run() {
    var q = input.value.trim();
    clearTimeout(timer);
    if (ctrl) { ctrl.abort(); ctrl = null; }
    if (q.length < 2) { showIdle(); return; }
    timer = setTimeout(function () { go(q); }, 220);
  }
  function go(q) {
    var my = ++seq;
    var c = ('AbortController' in window) ? new AbortController() : null; ctrl = c;
    res.classList.add('is-busy');
    suggest(q, c ? c.signal : undefined).then(function (d) {
      if (my !== seq) return;
      if (d.products.length) { render(q, d, null); return; }
      return fallback(q, d, my);
    }).catch(function (err) {
      if (err && err.name === 'AbortError') return;
      if (my !== seq) return;
      res.classList.remove('is-busy');
    });
  }

  /* D: Tippfehler / keine Treffer – Vorschlag, dann einzelne Wörter (längste zuerst) */
  function fallback(q, d0, my) {
    var cands = [];
    d0.queries.forEach(function (x) { var t = (x.text || '').trim(); if (t && t.toLowerCase() !== q.toLowerCase()) cands.push(t); });
    q.split(/\s+/).filter(function (w) { return w.length >= 3; }).sort(function (a, b) { return b.length - a.length; }).forEach(function (w) {
      if (cands.indexOf(w) === -1 && w.toLowerCase() !== q.toLowerCase()) cands.push(w);
      if (w.length >= 5) cands.push(w.slice(0, w.length - 1));
    });
    cands = cands.slice(0, 4);
    var i = 0;
    function next() {
      if (my !== seq) return;
      if (i >= cands.length) { renderNone(q, d0); return; }
      var cand = cands[i++];
      return suggest(cand).then(function (d) {
        if (my !== seq) return;
        if (d.products.length) render(q, d, cand); else return next();
      }).catch(function () { return next(); });
    }
    return next();
  }

  function card(p, i) {
    var gmin = parseFloat(p.price_min || p.price || 0), gmax = parseFloat(p.price_max || p.price || 0);
    var from = gmax > gmin ? T.from : '';
    var img = p.image || (p.featured_image && p.featured_image.url) || '';
    return '<a class="sp2s-card" href="' + esc(clean(p.url)) + '" data-sp2s-card>' +
      '<span class="sp2s-card__im">' + (img ? '<img src="' + esc(sized(img, 400)) + '" alt="" loading="' + (i < 3 ? 'eager' : 'lazy') + '" width="200" height="200">' : '') + '</span>' +
      '<span class="sp2s-card__t">' + (p.vendor ? '<span class="sp2s-l">' + esc(p.vendor) + '</span>' : '') +
      '<span class="sp2s-card__h">' + esc(p.title) + '</span>' +
      (gmin ? '<span class="sp2s-price"><b>' + from + eur(gmin / VAT) + '</b> <small>' + T.net + ' · ' + eur(gmin) + ' ' + T.gross + '</small></span>' : '') +
      '</span></a>';
  }
  function chips(list, cls) {
    return list.map(function (x) { return '<a class="sp2s-chip' + (cls || '') + '" href="' + esc(clean(x.url)) + '">' + esc(x.title || x.text) + '</a>'; }).join('');
  }
  function render(q, d, cand) {
    res.classList.remove('is-busy');
    idle.hidden = true; res.hidden = false;
    var h = '';
    if (cand) {
      h += '<p class="sp2s-note">' + T.none(q) + ' ' + T.show(cand) + ' · <a class="sp2s-tl" href="' + esc(searchUrl(q)) + '">' + T.orig(q) + '</a></p>';
    } else {
      h += '<div class="sp2s-row"><p class="sp2s-b">' + T.hits(d.products.length + (d.products.length >= 8 ? '+' : ''), q) + '</p>' +
        '<a class="sp2s-tl" href="' + esc(searchUrl(q)) + '">' + T.all + ' →</a></div>';
    }
    var sq = d.queries.filter(function (x) { return (x.text || '').toLowerCase() !== q.toLowerCase(); }).slice(0, 4);
    if (d.collections.length || sq.length) {
      h += '<div class="sp2s-chips">';
      if (d.collections.length) h += '<span class="sp2s-l">' + T.cats + '</span>' + chips(d.collections.slice(0, 4), ' sp2s-chip--c');
      if (sq.length) h += '<span class="sp2s-l">' + T.sugg + '</span>' + sq.map(function (x) { return '<button type="button" class="sp2s-chip" data-sp2s-q="' + esc(x.text) + '">' + esc(x.text) + '</button>'; }).join('');
      h += '</div>';
    }
    h += '<div class="sp2s-grid">' + d.products.slice(0, 8).map(card).join('');
    var showPreview = d.products.length <= 2 && d.collections.length;
    if (showPreview) h += '<a class="sp2s-prev" href="' + esc(clean(d.collections[0].url)) + '" data-sp2s-prev="' + esc(handleOf(d.collections[0].url)) + '"><span class="sp2s-prev__g"></span><span class="sp2s-prev__t"><span class="sp2s-l">' + esc(d.collections[0].title) + '</span><span class="sp2s-prev__h" data-sp2s-prev-n>' + T.more + ' →</span></span></a>';
    h += '</div>';
    res.innerHTML = h;
    if (showPreview) preview(d.collections[0]);
  }
  function handleOf(u) { var m = /\/collections\/([^/?#]+)/.exec(u || ''); return m ? m[1] : ''; }
  /* Kollektions-Vorschau: 4 Bilder + Anzahl */
  function preview(c) {
    var h = handleOf(c.url); if (!h) return;
    var el = res.querySelector('[data-sp2s-prev]'); if (!el) return;
    var base = ROOT + 'collections/' + h;
    fetch(base + '/products.json?limit=4').then(function (r) { return r.json(); }).then(function (d) {
      var g = el.querySelector('.sp2s-prev__g');
      g.innerHTML = (d.products || []).slice(0, 4).map(function (p) {
        var s = p.images && p.images[0] ? p.images[0].src : '';
        return '<span>' + (s ? '<img src="' + esc(sized(s, 200)) + '" alt="" loading="lazy">' : '') + '</span>';
      }).join('');
    }).catch(function () {});
    fetch(base + '.json').then(function (r) { return r.json(); }).then(function (d) {
      var n = d && d.collection && d.collection.products_count;
      var t = el.querySelector('[data-sp2s-prev-n]');
      if (n && t) t.textContent = T.models(n) + ' · ' + T.more + ' →';
    }).catch(function () {});
  }
  function renderNone(q, d) {
    res.classList.remove('is-busy');
    idle.hidden = true; res.hidden = false;
    var pop = Array.prototype.slice.call(idle.querySelectorAll('.sp2s-tiles .sp2s-tile, .sp2s-chips [data-sp2s-q]')).slice(0, 8);
    var h = '<p class="sp2s-note">' + T.none(q) + ' ' + T.nothing + '</p><div class="sp2s-chips">';
    pop.forEach(function (a) { h += a.outerHTML.replace('sp2s-tile', 'sp2s-chip'); });
    h += '</div>';
    if (cfg.help) h += '<a class="sp2s-help" href="' + esc(cfg.help) + '"><span class="sp2s-help__t"><span class="sp2s-help__h">' + T.helpT + '</span><span>' + T.helpS + '</span></span><span class="sp2s-help__b">' + T.helpB + '</span></a>';
    res.innerHTML = h;
  }

  input.addEventListener('input', run);
  form.addEventListener('reset', function () { setTimeout(showIdle, 0); });
  drawer.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sp2s-q]');
    if (b && box.contains(b)) {
      e.preventDefault();
      input.value = b.getAttribute('data-sp2s-q');
      saveRecent(input.value);
      input.focus();
      run();
      return;
    }
    if (e.target.closest('[data-sp2s-recent-clear]')) {
      try { localStorage.setItem(KEY, '[]'); } catch (err) {}
      renderRecent();
      return;
    }
    if (e.target.closest('[data-sp2s-card], .sp2s-prev, .sp2s-chip--c')) saveRecent(input.value);
  });
  /* Pfeiltasten: Feld → Karten → zurück */
  drawer.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    var links = Array.prototype.slice.call(box.querySelectorAll(res.hidden ? '[data-sp2s-idle] a, [data-sp2s-idle] button' : '[data-sp2s-res] a, [data-sp2s-res] button'));
    if (!links.length) return;
    var i = e.target === input ? -1 : links.indexOf(e.target);
    if (e.target !== input && i === -1) return;
    e.preventDefault();
    if (e.key === 'ArrowDown') (links[i + 1] || links[links.length - 1]).focus();
    else if (i <= 0) input.focus(); else links[i - 1].focus();
  });
  if (input.value.trim().length >= 2) run();
})();
